import styled, {css} from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;

  div{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    label {
      margin-right: 0.9rem;
      min-width: 70px;
      max-width: 70px;
      font-size: 0.9rem;
    }
    div{
      flex-direction: column;
      align-items: flex-start;
      input {
        border: 1px solid #b0b0b0;
        width: 100%;
        min-width: 250px;
        transition: border-color 0.7s;

        ${({isWarning}) => isWarning && css`border-color: red;`}

        @media (max-width: 770px) {
          max-width: 320px;
        }
      }
    }

  }

  + div {
    margin-top: 0.4rem;
  }


`;

export const Span = styled.span`
  color: red;
  font-size: 0.7rem;
  opacity: 0;
  max-height:0;
  transition: all 0.7s;
  @media (max-width: 770px) {
    margin-left:4rem;
    margin-top: 0.3rem;
  }

  ${({active}) => active && css`
    opacity:1;
    max-height: 100%;
  `}

`
